<div #dialogRoot cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{title}}</h2>
<div class="dialog-icon-row">
    <button mat-icon-button (click)="import()" matTooltip="Import">
        <mat-icon color="primary">file_upload</mat-icon>
    </button>
    <button mat-icon-button (click)="Export()" matTooltip="Export">
        <mat-icon color="primary">file_download</mat-icon>
    </button>
    <button mat-icon-button (click)="CopyJSON()" matTooltip="Copy JSON">
        <img src="assets/images/Copy JSON Button.png"
            alt="Copy JSON"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="CopyText()" matTooltip="Copy Text">
        <img src="assets/images/Copy Text Button.png"
            alt="Copy Text"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="PasteJSON()" matTooltip="Paste JSON">
        <img src="assets/images/Paste JSON Button.png"
            alt="Paste JSON Button"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="PasteText()" matTooltip="Paste Text">
        <img src="assets/images/Paste Text Button.png"
            alt="Paste Text"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button class="red-icon-btn" (click)="DeleteAll()" matTooltip="Delete All">
        <mat-icon>delete_sweep</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div cdkDropList >
        <div class="find-replace-row">
            <div  style="position: relative; display: inline-block; margin-right: 14px; display: flex;align-items: center;">
                <div style="position: relative; display: inline-block; margin-right: 14px;">
                <!-- Reorder icon -->
                <div class="reorder-col" style="visibility: hidden;">
                    <mat-icon
                    color="primary"
                    matTooltip="Re-order"
                    matTooltipPosition="above"
                    #reorderTooltip="matTooltip"
                    
                    style="cursor: grab; font-size: 18px;margin-left: 10px;line-height: 20px;"
                    cdkDrag
                    cdkDragRootElement=".drag-component"
                    cdkDragHandle
                    >
                    reorder
                    </mat-icon>
                    <!-- Number: positioned tightly to top-right corner -->
                    <span class="number-badge" style="margin-right: 10px;margin-top: -5px;">
                    &nbsp;1&nbsp;
                    </span>
                </div>

                </div>
                <ng-container [ngSwitch]="fieldType">
                    <!-- edit -->
                    <ng-container *ngSwitchCase="'edit'">
                        <mat-form-field #textboxmatform class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelFind}}</mat-label>
                            <input #textbox   id="add-input" cdkFocusInitial matInput [(ngModel)]="viewModel.find" placeholder="{{placeholderFind}}" (keydown.enter)="addItem()" 
                            [matTooltip]="duplicateWarningMessage" 
                            [matTooltipDisabled]="!isDuplicate" 
                            matTooltipClass="findreplace-warning-tooltip"
                            matTooltipShowDelay="0"
                            matTooltipHideDelay="1000"
                            #newReplaceTooltip="matTooltip"
                            (ngModelChange)="onInputChange()"
                            >
                            <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>
                        <mat-icon class="icon" [style.color]="viewModel.currentColor.color">keyboard_arrow_right</mat-icon>
                        <mat-form-field #textboxmatformreplace class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelReplace}}</mat-label>
                            <input #textbox  matInput [(ngModel)]="viewModel.replace" placeholder="{{placeholderReplace}}" (keydown.enter)="addItem()"
                            [matTooltip]="duplicateWarningMessage" 
                            [matTooltipDisabled]="!isDuplicate" 
                            matTooltipClass="findreplace-warning-tooltip"
                            matTooltipShowDelay="0"
                            matTooltipHideDelay="1000"
                            #newReplaceTooltip="matTooltip"
                            (ngModelChange)="onInputChange()"
                            >
                            <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>

                        <button title="Add" (click)="addItem()" mat-icon-button>
                            <mat-icon class="icon" color="primary">add_box</mat-icon>
                        </button>
                    </ng-container>
                    <!-- Dropdown -->
                    <ng-container *ngSwitchCase="'dropdown'">
                        <mat-form-field #textboxmatform class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelFind}}</mat-label>
                            <input #textbox  id="add-input" cdkFocusInitial  matInput [(ngModel)]="viewModel.find" placeholder="{{placeholderFind}}" (keydown.enter)="addItem()" 
                            [matTooltip]="duplicateWarningMessage" 
                            [matTooltipDisabled]="!isDuplicate" 
                            matTooltipClass="findreplace-warning-tooltip"
                            matTooltipShowDelay="0"
                            matTooltipHideDelay="1000"
                            #tooltip="matTooltip"
                            (ngModelChange)="onInputChange()"
                            >
                            <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>
                        <mat-icon class="icon" [style.color]="viewModel.currentColor.color">keyboard_arrow_right</mat-icon>
                        <mat-form-field #textboxmatformreplace class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelReplace}}</mat-label>
                            <input #textbox  matInput [(ngModel)]="viewModel.replace" placeholder="{{placeholderReplace}}" (keydown.enter)="addItem()">
                            <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>

                        <button title="Add" (click)="addItem()" mat-icon-button>
                            <mat-icon class="icon" color="primary">add_box</mat-icon>
                        </button>
                    </ng-container>
                    <!-- autocomplete -->
                    <ng-container *ngSwitchCase="'autocomplete'">
                        <mat-form-field #textboxmatform class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelFind}}</mat-label>
                            <input #textbox   id="add-input" cdkFocusInitial matInput [(ngModel)]="viewModel.find" placeholder="{{placeholderFind}}" (keydown.enter)="onKeyEnter()" 
                            [matTooltip]="duplicateWarningMessage" 
                            [matTooltipDisabled]="!isDuplicate" 
                            matTooltipClass="findreplace-warning-tooltip"
                            matTooltipShowDelay="0"
                            matTooltipHideDelay="1000"
                            #newFindTooltip="matTooltip"
                            (ngModelChange)="onInputChange()"
                            [formControl]="inputFindControl" [matAutocomplete]="find"
                            >
                            <mat-autocomplete #find="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptionsFind | async" [value]="option">
                                    {{ option }}
                                </mat-option>
                            </mat-autocomplete>
                            <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>
                        <mat-icon class="icon" [style.color]="viewModel.currentColor.color">keyboard_arrow_right</mat-icon>
                        <mat-form-field #textboxmatformreplace class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                            <mat-label>{{labelReplace}}</mat-label>
                            <input #textbox  matInput [(ngModel)]="viewModel.replace" placeholder="{{placeholderReplace}}" (keydown.enter)="validateSelection()"
                            [matTooltip]="duplicateWarningMessage" 
                            [matTooltipDisabled]="!isDuplicate" 
                            matTooltipClass="findreplace-warning-tooltip"
                            matTooltipShowDelay="0"
                            matTooltipHideDelay="1000"
                            #newReplaceTooltip="matTooltip"
                            (ngModelChange)="onInputChange()"
                            [formControl]="inputReplaceControl" [matAutocomplete]="replace">
                            <mat-autocomplete #replace="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptionsReplace | async" [value]="option">
                                    {{ option }}
                                </mat-option>
                            </mat-autocomplete>
                            <div matPrefix class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                        </mat-form-field>

                        <button title="Add" (click)="validateSelection()" mat-icon-button>
                            <mat-icon class="icon" color="primary">add_box</mat-icon>
                        </button>
                    </ng-container>
                </ng-container> 
            </div>          
        </div>
    </div>
    <div class="dashed-line"></div>
    <div cdkDropList [cdkDropListData]="viewModel.textItems" (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let item of viewModel.textItems;let i = index">
            <div class="find-replace-row-list"  [attr.data-row-index]="i">
                <div style="position: relative; display: inline-block; margin-right: 14px; display: flex;align-items: center;">
                    <div style="position: relative; display: inline-block; margin-right: 14px;">
                        <!-- Reorder icon -->
                        <div class="reorder-col" >
                            <mat-icon
                                color="primary"
                                matTooltip="Re-order"
                                matTooltipPosition="above"
                                #reorderTooltip="matTooltip"
                                (mouseenter)="reorderTooltip.show()"
                                (mouseleave)="reorderTooltip.hide()"
                            style="cursor: grab; font-size: 18px;margin-left: 10px;line-height: 20px;"
                                cdkDrag
                                cdkDragRootElement=".drag-component"
                                cdkDragHandle
                            >
                                reorder
                            </mat-icon>
                            <!-- Number: positioned tightly to top-right corner -->
                            <span class="number-badge" style="margin-right: 10px;margin-top: -5px;">
                                &nbsp;{{ i + 1 }}&nbsp;
                            </span>
                        </div>
                    </div>
                    <ng-container [ngSwitch]="fieldType">
                        <!-- edit -->
                        <ng-container *ngSwitchCase="'edit'">
                            <mat-form-field class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="auto">
                                <input [id]="'findInput' + i" (keydown.enter)="focusNext(i + 1)"  matInput [(ngModel)]="item.find" placeholder="{{placeholderFind}}" required
                                #findTooltip="matTooltip"
                                [matTooltip]=""
                                matTooltipClass="findreplace-warning-tooltip"
                                >
                                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            </mat-form-field>
                            <mat-icon class="icon" [style.color]="item.color.color">keyboard_arrow_right</mat-icon>
                            <mat-form-field class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="auto">
                                <input [id]="'replaceInput' + i" (keydown.enter)="focusNext(i + 1)"  matInput [(ngModel)]="item.replace" placeholder="{{placeholderReplace}}" required
                                #replaceTooltip="matTooltip"
                                [matTooltip]=""
                                matTooltipClass="findreplace-warning-tooltip"
                                >
                                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            </mat-form-field>

                            <button mat-icon-button>
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)">delete_forever</mat-icon>
                            </button>
                        </ng-container>
                        <!-- Dropdown -->
                        <ng-container *ngSwitchCase="'dropdown'">
                            <mat-form-field #textboxmatform class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                                <mat-label>{{labelFind}}</mat-label>
                                <input #textbox  matInput [(ngModel)]="viewModel.find" placeholder="{{placeholderFind}}" (keydown.enter)="addItem()" 
                                [matTooltip]="duplicateWarningMessage" 
                                [matTooltipDisabled]="!isDuplicate" 
                                matTooltipClass="findreplace-warning-tooltip"
                                matTooltipShowDelay="0"
                                matTooltipHideDelay="1000"
                                #tooltip="matTooltip"
                                (ngModelChange)="onInputChange()"
                                >
                                <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                            </mat-form-field>
                            <mat-icon class="icon" [style.color]="viewModel.currentColor.color">keyboard_arrow_right</mat-icon>
                            <mat-form-field #textboxmatformreplace class="mat-form-field-no-padding" class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                                <mat-label>{{labelReplace}}</mat-label>
                                <input #textbox  matInput [(ngModel)]="viewModel.replace" placeholder="{{placeholderReplace}}" (keydown.enter)="addItem()">
                                <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                            </mat-form-field>

                            <button mat-icon-button>
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)" style="font-size: 2em;float: inline-start;">delete_forever</mat-icon>
                            </button>
                        </ng-container>
                        <!-- autocomplete -->
                        <ng-container *ngSwitchCase="'autocomplete'">
                            <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                                <mat-label>{{labelFind}}</mat-label>
                                <input [id]="'findInput' + i"  matInput [(ngModel)]="item.find" placeholder="{{placeholderFind}}" required 
                                [matAutocomplete]="find"
                                #findTooltip="matTooltip"
                                [matTooltip]=""
                                matTooltipClass="findreplace-warning-tooltip"
                                [formControl]="inputFindControlList[i]"
                                >
                                <mat-autocomplete #find="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptionsFindList[i] | async" [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-autocomplete>
                                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            </mat-form-field>
                            <mat-icon class="icon" [style.color]="item.color.color">keyboard_arrow_right</mat-icon>
                            <mat-form-field class="mat-form-field-no-padding" appearance="outline" floatLabel="always">
                                <mat-label>{{labelReplace}}</mat-label>
                                <input [id]="'replaceInput' + i"  matInput [(ngModel)]="item.replace" placeholder="{{placeholderReplace}}" required
                                [matAutocomplete]="replace"
                                #replaceTooltip="matTooltip"
                                [matTooltip]=""
                                matTooltipClass="findreplace-warning-tooltip"
                                [formControl]="inputReplaceControlList[i]"
                                >
                                <mat-autocomplete #replace="matAutocomplete">
                                    <mat-option *ngFor="let option of filteredOptionsReplaceList[i] | async" [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-autocomplete>
                                <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            </mat-form-field>

                            <button mat-icon-button>
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)" style="font-size: 2em;float: inline-start;">delete_forever</mat-icon>
                            </button>
                        </ng-container>
                    </ng-container>    
                </div>
            </div>
            <div class="dashed-line"></div>
        </ng-container>
    </div>
    <h3 style="color: #1ea9d3;margin-top: 5px;">Preview</h3>

    <div style="white-space: normal; word-wrap: break-word;"><span 
        style="margin-left: 2px; margin-right: 2px;white-space: pre;" 
        *ngFor="let containItem of viewModel.textItems"
        [style.color]="containItem.color.color">{{containItem.find}} > {{containItem.replace}}</span></div>
</mat-dialog-content>

<!-- <mat-dialog-actions align="end">
    <button (click)="save()" color="primary" mat-raised-button tabindex="0">SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close tabindex="0">CANCEL</button>
</mat-dialog-actions> -->

<mat-dialog-actions align="end">
    <button (click)="save()"  class="save-btn" color="primary" mat-raised-button  >SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close >CANCEL</button>
</mat-dialog-actions>
</div>